module.exports = __webpack_public_path__ + "media/images/choose/forms-c993cbe88c26f7af72a3064a7bd2251e.png";